export * as incorrectDoorNumber from './incorrect-door-number'
export * as roomDoesNotExists from './room-does-not-exists'
export * as incorrectFloorPlan from './incorrect-floor-plan'
